import { supabase } from '../supabase';
import * as Sentry from '@sentry/react';

// A client's daily calorie and protein totals for their coach (migration 100): one line per day they
// logged, with that day's calories and protein added up and the plan's calorie and protein targets and
// maintenance estimate. Never what they ate. How far back the coach brief looks:
export const FOOD_WINDOW_DAYS = 14;

// Postgres' (42883) and PostgREST's (PGRST202) "there is no such function": migration 100 is not run yet.
const isMissingFunction = (error) => error?.code === '42883' || error?.code === 'PGRST202';
// "You cannot see this client's food totals": not their coach any more, or signed out. Expected, not a fault.
const isNotAllowed = (error) => error?.code === '42501';

// Returns the summary, or null when there is nothing to say about food: a client who has not agreed to
// share health information (migration 101), a coach who may not see this client, the migration not run
// yet, or a failed read. The coach brief leaves food out for null, and never treats it as "nothing logged".
export async function loadClientFoodSummary(clientUserId, days = FOOD_WINDOW_DAYS) {
  const { data, error } = await supabase.rpc('coach_food_summary', { p_client: clientUserId, p_days: days });
  if (error) {
    if (!isMissingFunction(error) && !isNotAllowed(error)) {
      Sentry.captureException(new Error(error.message), { extra: { fn: 'loadClientFoodSummary', supabaseError: error, clientUserId } });
    }
    return null;
  }
  return data ?? null;
}
